<template>
  <div class="page-home page-wrapper">
    <div class="pc" v-if="!isPhone">
      <div class="content-wrapper clearfix">
      <!-- Banner区域 -->
      <div :class="['content-wrapper-left']">
        <div class="swiperBanner-piyaoRankList clearfix">
          <div v-if="swiperData && swiperData.length" class="swiper-container banner-swiper fLeft">
            <div class="swiper-wrapper">
              <div class="swiper-slide pointer" v-for="(item, i) in swiperData" :key="i">
                  <div class="img bgc-default">
                    <img :src="item.imgUrl || require('./../assets/img/default.png')" :onload="imgLoaded" :onerror="errorImg" alt/>
                    <span v-show="item.flag == 3" class="video-icon"></span>
                  </div>
                  <div class="title">
                    <div class="line-2">
                      <span v-show="item.flag == 1" class="label-banner-wap" :class="{'label-activity': item.flag == 1}">专题</span>
                      {{item.itemTitle}}
                    </div>
                  </div>
              </div>
            </div>
            <div class="swiper-toLeft swiper-arrow arrow-wrapper">
              <div class="arrow-wrapper"></div>
            </div>
            <div class="swiper-toRight swiper-arrow arrow-wrapper">
              <div class="arrow-wrapper"></div>
            </div>
            <!-- <div class="swiper-pagination" slot="pagination"></div> -->
          </div>
          <div class="piyaoRankList hasBnnnerRanking">
              <ReportingEntrance />
          </div>
        </div>
        <div class="img-box">
          <img :src="item.img" alt="" v-for="(item,index) in fixList" :key="index" @click="toDetailOrTop(item)" :id="item.id">
        </div>
        <!-- 最新辟谣 -->
        <div class="latest-kill-rumor">
          <div class="common-title">
            <span @click="update">最新辟谣</span>
          </div>
          <div class="list">
            <div class="list-left">
              <NewsList :column="column" :list="beforeList" :type="1"/>
              <!-- 专题推荐部分 -->
              <div class="list-subject" v-if="subjectList && subjectList.length >= 4">
                <div class="title-load clearfix">
                  <div class="title">专题推荐</div>
                  <div class="seeMore pointer" @click="toDetail({type: 6})">查看更多</div>
                </div>
              </div>
              <NewsList :column="column" :list="list" :type="1" channelId="100" />
            </div>
            <div class="list-right">
              <div class="list-right-item" v-for="(item,key) in recommendColumn" :key="item.id">
                <!-- relateType 1：外链，2：专题  -->
                <img v-if="item.relateType === 1" :src="item.link.img52 || item.link.img31" alt="" @click="toDetail(item)">
                <img v-if="item.relateType === 2" :src="item.subject.img52 || item.subject.img31" alt="" @click="toDetail(item)">
              </div>
            </div>
          </div>
        </div>
        <div class="loadMore pointer" @click="update">
          {{isLoading ? '加载更多...' : (lastDataId == -1 ? '已经到底了' : '点击加载更多')}}
        </div>
      </div>
    </div>
    </div>
    <div class="wap" v-if="isPhone">
      <div class="content-wrapper">
        <div v-if="swiperData && swiperData.length" class="swiper-container">
          <div class="swiper-wrapper">
            <a :href="toWapDetail(item, true)" class="swiper-slide" v-for="(item, i) in swiperData" :key="i">
                <div class="img">
                  <img :src="item.imgUrl || require('./../assets/img/default.png')" :onload="imgLoaded" :onerror="errorImg" alt/>
                  <span v-show="item.flag == 3" class="video-icon"></span>
                </div>
                <div class="title"> 
                  <div class="titleName line-2">
                    <span v-show="item.flag == 1" class="label-banner-wap" :class="{'label-activity': item.flag == 1}">专题</span>
                    {{item.itemTitle}}
                  </div>
                </div>
            </a>
          </div>
          <div class="swiper-pagination" slot="pagination"></div>
        </div>
        <div class="img-box-wap">
          <img :src="item.img" alt="" v-for="(item,index) in fixList" :key="index" @click="toDetailOrTop(item)" :id="item.id">
        </div>
        <NewsList :list="list" channelId="100"/>
        <div class="loadMore">
          {{isLoading ? '———— 加载更多... ————' : (lastDataId == -1 ? '———— 已经到底了 ————' : '———— 上拉加载更多 ————')}}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Swiper from 'swiper/js/swiper.min.js';
import 'swiper/css/swiper.css';
import NewsList from "@/components/NewsList";
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { mapMutations, mapState } from 'vuex';
import ReportingEntrance from '@/components/ReportingEntrance.vue';
export default {
  name: "Home",
  components: {
    NewsList,
    Header,
    Footer,
    ReportingEntrance
  },
  data() {
    return {
      isLoading: false,
      swiperData: [],
      swiper: null,
      matrixSwiper: null,
      beforeList: [],
      page: 1,
      list: [],
      lastDataId: null,
      subjectLastId: null,
      recommendColumn: [],
      subjectList: null,
      rankList: null, // 辟谣榜单
      aside_fixed: false,
      aside_absolute: false,
      imgLoaded: `this.style.background = 'none'`,
      errorImg: 'this.src="'+ require('./../assets/img/default.png') + '"',
      fixColumn:[
        // {
        //   type:2,
        //   externalUrl:'https://www.piyao.org.cn/index.htm',
        //   img:require('./../assets/img/piyao_1.png') 
        // },
        // {
        //   type:2,
        //   externalUrl:'https://www.piyao.org.cn/jrpy/index.htm',
        //   img:require('./../assets/img/piyao_2.png') 
        // },
        // {
        //   type:2,
        //   externalUrl:'https://www.piyao.org.cn/rm/bd.htm',
        //   img:require('./../assets/img/piyao_3.png') 
        // }
      ],
      fixList:[
        {
          type:2,
          externalUrl:'https://www.scjb.gov.cn/reportInstructions/8',
          img:require('./../assets/img/piyao_4.png') 
        },
        {
          id:'img-to-top',
          type:1,
          externalUrl:'',
          img:require('./../assets/img/piyao_5.png') 
        },
        {
          type:2,
          externalUrl:'https://www.scjb.gov.cn/',
          img:require('./../assets/img/piyao_6.png') 
        }
      ],
      lastDataId: null
    };
  },
  created() {
    document.title = "四川互联网举报辟谣平台";
    this.init();
  },
  mounted() {
    this.isPhone && this.$Common.onShare({
      shareTitle: '四川互联网举报辟谣平台',
      shareUrl: window.location.href
    })
    if (!this.isPhone && !this.matrixSwiper) {
      this.$nextTick(() => {
        this.matrixSlide()
      })
    }
  },
  methods: {
    ...mapMutations(['setLoadingShow','setSearchIsShow']),
    init() {
      this.getSubjectList();
      this.getChannelList();
      this.setLoadingShow(false)
    },
    getChannelList(){
      this.isLoading = true;
      const params = {
        channelId: this.$route.params.channelId ? this.$route.params.channelId : 100,
        pageSize: this.isPhone ? 20 : 45,
        queryType: this.swiperData.length ? 2 : 1,
        queryAllImg: true
      }
      if (this.lastDataId) {
        params.lastDataId = this.lastDataId
        params.lastDataType = 0
      }
      if(this.isPhone) params.queryAllImg = true
      this.$axios.get(this.$ApiInfo.getChannelItemList, params).then(res => {
        if (res.channel) {
          document.title = res.channel.id == 100 ? '四川互联网举报辟谣平台' : res.channel.name
        }
        this.isLoading = false;
        this.lastDataId = res.lastDataId
        if (res.banner && res.banner.length) {
          this.swiperData = res.banner
        }
        if(!this.isPhone){
          this.$nextTick(() => {
            this.swiperData && this.swiperData.length && this.slide();
          })
        }
        
        if(this.isPhone) {
          this.list = this.list.concat(res.list);
          this.$nextTick(() => {
            if(!this.swiper) this.swiperData && this.swiperData.length && this.slide();
            let footerHeight = 0;
            document.querySelector('.footer-wrapper') && (footerHeight = document.querySelector('.footer-wrapper').clientHeight - 50)
            this.$Common.loadScroll(footerHeight, this.update)
          })
          return;
        }
        this.list = this.list.concat(res.list)
      })
    },
    update() {
      if(this.lastDataId == -1 || this.isLoading) {
        return;
      }
      this.getChannelList()
    },
    slide() {
      let that = this
      if (this.isPhone) {
        this.swiper = new Swiper('.swiper-container', {
          spaceBetween: 0,
          pagination: {
            el: ".swiper-pagination",
            clickable: true
          },
          autoplay: {
            delay: 3000,
            disableOnInteraction: false
          },
          loop: true
        })
        return
      }
      this.swiper = new Swiper('.banner-swiper', {
        spaceBetween: 30,
        pagination: {
          el: ".swiper-pagination",
          clickable: true
        },
        autoplay: {
          delay: 3000,
          disableOnInteraction: false
        },
        loop: true,
        on: {
          click: function(e) {
            let domClass = e.target.className
            if (domClass && domClass.indexOf('arrow-wrapper') > -1) {
              return
            }
            let index = this.realIndex
            that.bannerClick(index)
          }
        },
        navigation: {
          nextEl: '.swiper-toRight',
          prevEl: '.swiper-toLeft',
        },
      })
    },
    matrixSlide() {
      if (this.colums && this.colums.length > 6) {
        this.matrixSwiper = new Swiper('.matrix-swiper', {
          slidesPerView : "auto",
          // slidesPerGroup : 6,
          observer: true,
          observeParents: true,
          navigation: {
            nextEl: '.maxtrix-swiper-toRight',
            prevEl: '.maxtrix-swiper-toLeft',
          },
        })
      }
    },
    bannerClick(index) {
      const item = this.swiperData[index]
      this.toNewsDetail(item, true)
    },
    toDetail(item) {
      if (item.relateType === 1) {
        // 外链
        window.open(item.link.linkUrl)
      } else {
        // 专题
        window.open(this.$router.resolve({
          path: `/subject/${this.$Common.Base64.encode(item.subject.subjectId)}`
        })['href'], '_blank');
      }
    },
    toDetailOrTop(item){
      if(item.type === 2){
        window.open(item.externalUrl)
      }else{
        // ----------跳转到搜索页面
        this.$router.push('/search')
      }
    },
    toNewsDetail(item, judgeSubject) {
      // 辟谣没有直播和图集
      if (item.flag == 2 || item.flag == 5) return
      let url = ''
      // flag  跳转方式  0-新闻 1-专题 2-直播 3-视频 4-外链  5-图集
      switch (item.flag) {
        case 0:
          url = this.$router.resolve({
              path: `/news/${this.$Common.Base64.encode(item.itemId)}/${this.$Common.Base64.encode(100)}`
          })['href']
          break;
        case 1:
          url = this.$router.resolve({
              path: `/subject/${this.$Common.Base64.encode(item.itemId)}`
          })['href']
          break;
        case 3:
        url = this.$router.resolve({
              path: `/news/${this.$Common.Base64.encode(item.itemId)}`
          })['href']
          break;
        case 4:
          url = item.itemExternalUrl
          break;
        default:
          break;
      }
      window.open(url)
      
    },
    toWapDetail(item, judgeSubject) {
      // let url = ''
      // if(item.type == 3) {
      //   url = item.url
      // } else if(judgeSubject && item.isSubjectEntrance) {
      //   url = this.$router.resolve({
      //       path: `/subject/${this.$Common.Base64.encode(item.subjectId)}`
      //   })['href']
      // } else if(item.newsKind == 6) {
      //   url = item.externalUrl
      // } else {
      //   url = this.$router.resolve({
      //       path: `/news/${this.$Common.Base64.encode(item.id)}`
      //   })['href']
      // }
      // return url
      // 辟谣没有直播和图集
      if (item.flag == 2 || item.flag == 5) return
      let url = ''
      // flag  跳转方式  0-新闻 1-专题 2-直播 3-视频 4-外链  5-图集
      switch (item.flag) {
        case 0:
          url = this.$router.resolve({
              path: `/news/${this.$Common.Base64.encode(item.itemId)}/${this.$Common.Base64.encode(100)}`
          })['href']
          break;
        case 1:
          url = this.$router.resolve({
              path: `/subject/${this.$Common.Base64.encode(item.itemId)}`
          })['href']
          break;
        case 3:
        url = this.$router.resolve({
              path: `/news/${this.$Common.Base64.encode(item.itemId)}`
          })['href']
          break;
        case 4:
          url = item.itemExternalUrl
          break;
        default:
          break;
      }
      return url
    },
    toSubject(item) {
      window.open(this.$router.resolve({
          path: `/subject/${this.$Common.Base64.encode(item.id)}`
      })['href'], '_blank');
    },
    getSubjectList() {
      this.$axios.get(this.$ApiInfo.getSubjectList,{tabId: 2}).then(res => {
        if (res.list && res.list.length) {
          this.recommendColumn = res.list
        }
      })
    },
    watchSubject() {
      let subjectWrapper = document.getElementById('content-wrapper-right')
      let header = document.getElementById('header-wrapper')
      let scrollTop = document.body.scrollTop || document.documentElement.scrollTop
      if (scrollTop <= 0) {
        this.aside_fixed = false
        this.aside_absolute = false
        return
      }
      let footerHeight = 0;
      document.querySelector('.footer-wrapper') && (footerHeight = document.querySelector('.footer-wrapper').clientHeight)
      if (scrollTop >= header.clientHeight + subjectWrapper.clientHeight - (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight)) {
        if(Math.ceil((document.body.scrollTop || document.documentElement.scrollTop))
          + (window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight)
          >= (document.documentElement.scrollHeight || document.body.scrollHeight) - footerHeight
        ) {
          this.aside_absolute = true
          this.aside_fixed = false
        } else {
          this.aside_fixed = true
          this.aside_absolute = false
        }
      } else {
        this.aside_fixed = false
        this.aside_absolute = false
      }
    }
  },
  computed: {
    ...mapState(['indexChannel', 'columnList', 'closeColumnList']),
    cyId() {
      if(this.isProduction) return 306;
      else return 424;
    },
    colums() {
      return this.columnList.filter(v => v.id != this.cyId);
    },
    hasColumn() {
      return this.columnList && this.columnList.length
    },
    column() {
      return this.hasColumn ? 3 : 4
    },
    isPhone() {
      return this.$Common.Attribute.isMb()
    },
    pageSize() {
      return this.isPhone ? 20 : 45
    },
    hasSubject() { // 默认专题数据一直存在
      return this.recommendColumn.length > 0
    },
    isProduction() {
      return location.host == 'piyao-web.thecover.cn' || location.host == 'scpiyao.org.cn' || location.host == 'www.scpiyao.org.cn'
    },
    piyaoChannelId() {
      if (this.isProduction) {
        return 3914
      }
      return 4000
    },
  },
  watch: {
    colums(val) {
      if (val && val.length && !this.isPhone) {
        this.$nextTick(() => {
          this.matrixSlide()
        })
      }
    },
    closeColumnList(){
      this.getSubjectList()
    }
  }
};
</script>
<style lang="less">
.page-home {
  .pc {
    .imgcenter {
      width: 100%;
      height: 13.875rem;
      background: linear-gradient(329deg, #006DF1 0%, #007AF6 100%);
    }
    .content-wrapper {
      margin-top: 1.25rem;
      position: relative;
      .swiper-pagination {
          box-sizing: border-box;
          text-align: right;
          padding-right: 0.625rem;
          .swiper-pagination-bullet {
            width: 0.375rem;
            height: 0.375rem;
            background: #D8D8D8;
            opacity: 1;
            outline: none;
          }
          .swiper-pagination-bullet-active {
            background: #006DF1;
          }
      }
      .common-title {
        // border-bottom: 1px solid #eee;
        font-size: 1.125rem;
        margin-bottom: 1.5rem;
        background: linear-gradient(90deg, #006DF1 0%, #ffffff 100%);
        span {
          display: inline-block;
          color: #ffffff;
          // border-bottom: 1px solid #006df1;
          padding-left: .25rem;
          line-height: 2.5rem;
        }
      }
      .content-wrapper-left {
        // width: 47.625rem;
        // float: left;
        .swiperBanner-piyaoRankList {
          .swiper-container {
            // width: 24.25rem;
            width: 31.25rem;
            height: 17.5781rem;
            .swiper-slide {
              .img {
                .video-icon {
                    position: absolute;
                    width: 3.1875rem;
                    height: 3.1875rem;
                    background: url('../assets/img/video_play.png') center no-repeat;
                    background-size: cover;
                    top: 50%;
                    left: 50%;
                    transform: translate(-50%, -50%);
                }
              }
              .title {
                width: 100%;
                padding: 1.75rem 2.0625rem .5625rem;
                box-sizing: border-box;
                color: #ffffff;
                font-size: .875rem;
                line-height: 1.25rem;
                position: absolute;
                bottom: 0;
                left: 0;
                background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.66) 100%);
                .tyBannerlabel {
                  padding: 0.125rem 0.375rem;
                  font-size: 0.75rem;
                  text-align: center;
                  color: #fff;
                  background: linear-gradient(149deg, #2479FF 0%, #244EFF 100%);
                }
              }
            }
            .swiper-arrow {
              width: 1.8rem;
              height: 1.8rem;
              position: absolute;
              bottom: 0.24rem;
              z-index: 99;
              outline: none;
              cursor: pointer;
            }
            .swiper-toLeft {
              left: .2625rem;
              div {
                display: block;
                content: '';
                width: .5625rem;
                height: .5625rem;
                border-top: 2px solid #ffffff;
                border-left: 2px solid #ffffff;
                transform: rotate(-45deg);
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                margin: auto;
              }
            }
            .swiper-toRight {
              right: .2625rem;
              div {
                display: block;
                content: '';
                width: .5625rem;
                height: .5625rem;
                border-top: 2px solid #ffffff;
                border-right: 2px solid #ffffff;
                transform: rotate(45deg);
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
                margin: auto;
              }
            }
          }
          .piyaoRankList {
            // height: 13.6875rem;
            height: 17.5781rem;
            .title {
              height: 2.375rem;
              color: #ffffff;
              font-size: 1.25rem;
              line-height: 2.375rem;
              font-weight: bold;
              letter-spacing: .2125rem;
              background: linear-gradient(201deg, #00A6F9 0%, #006DF1 100%);
              text-align: center;
            }
            .list {
              padding: .875rem;
              background: #F9F9F9;
              // height: 11.3125rem;
              height: calc(100% - 2.375rem);
              box-sizing: border-box;
              .list-item {
                font-size: .9375rem;
                color: #333333;
                // line-height: 1.25rem;
                line-height: 1.9rem;
                margin-bottom: .9375rem;
                .indexNum {
                  color: #FA6400;
                  font-weight: bold;
                  float: left;
                }
                .color-gray {
                  color: #999999;
                }
                .newsTitle {
                  margin-left: 1.125rem;
                }
                &:last-of-type {
                  margin-bottom: 0;
                }
              }
            }
          }
          .hasBnnnerRanking {
            // width: 22.75rem;
            width: 31.25rem;
            float: right;
          }
        }
        .img-box{
          display: flex;
          justify-content: space-between;
          margin-top: 1.25rem;
          img{
            width: 20.6rem;
            cursor: pointer;
          }
        }
        .column-matrix {
          margin-top: 1.25rem;
          .list {
            // margin-left: -1.375rem;
            padding: 0 1.25rem;
            position: relative;
            .matrix-swiper {
              width: 100%;
              // height: 2.75rem;
              .swiper-wrapper {
                width: 100%;
                height: 100%;
                .swiper-slide {
                  display: inline-block;
                  width: auto;
                  margin-right: .75rem;
                  // overflow: hidden;
                  .columnOnlyImg {
                    width: 6.875rem;
                    height: 2.75rem;
                    border-radius: 0.3125rem;
                    background-repeat: no-repeat;
                    background-position: center;
                    background-size: cover;
                    transition: all .3s;
                    &:hover {
                      transform: scale(1.1);
                    }
                  }
                  .columnImgText {
                    width: 5.875rem;
                    text-align: center;
                    .img {
                      display: inline-block;
                      width: 3.875rem;
                      height: 3.875rem;
                      // border-radius: 50%;
                      margin-bottom: .5rem;
                      background-size: cover;
                      background-position: center;
                      background-repeat: no-repeat;
                      transition: all .3s;
                      &:hover {
                        transform: scale(1.12);
                      }
                    }
                    .text {
                      font-size: .875rem;
                      color: #000;
                      text-align: center;
                    }
                  }
                }
              }
            }
            .swiper-arrow {
              width: .75rem;
              height: 100%;
              background: #308EFF;
              border-radius: .25rem;
              position: absolute;
              top: 0;
              outline: none;
              cursor: pointer;
              div {
                width: .25rem;
                height: .25rem;
                position: absolute;
                color: #ffffff;
                border-top: 1px solid #ffffff;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                margin: auto;
              }
            }
            .swiper-toLeft {
              div {
                left: 1px;
                border-left: 1px solid #ffffff;
                transform: rotate(-45deg);
              }
              left: 0;
            }
            .swiper-toRight {
              div {
                right: 1px;
                border-right: 1px solid #ffffff;
                transform: rotate(45deg);
              }
              right: 0;
            }
            .swiper-button-disabled {
              opacity: .4;
            }
          }
          .noPadding {
            padding: 0;
          }
        }
        .noBanner-column-matrix {
          margin-top: -0.625rem;
        }
        .latest-kill-rumor {
          margin-top: 1.25rem;
          .list {
            display: flex;
            justify-content: space-between;
            .list-left{
              width: 47.625rem;
            }
            .list-right{
              width: 14.875rem;
              .list-right-item{
                margin-bottom: 0.8rem;
                cursor: pointer;
                img{
                  width: 100%;
                }
              }
            }
            .list-subject {
              width: 100%;
              height: 16.875rem;
              background: #eee;
              margin-bottom: 1.5rem;
              background: url('./../assets/img/new_subject_recommond_bg.png') center no-repeat;
              background-size: cover;
              box-sizing: border-box;
              padding: 1.1875rem;
              .title-load {
                color: #006DF1;
                .title {
                  font-size: 1.125rem;
                  line-height: 1.125rem;
                  padding-left: 0.375rem;
                  border-left: 0.25rem solid #006DF1;
                  float: left;
                }
                .seeMore {
                  font-size: 0.625rem;
                  line-height: 1.125rem;
                  float: right;
                  color: #666666;
                  &::after {
                    display: inline-block;
                    content: '';
                    border-top: 1px solid #666666;
                    border-right: 1px solid #666666;
                    width: .25rem;
                    height: .25rem;
                    transform: rotate(45deg);
                    margin-bottom: 2px;
                  }
                }
              }
              .content {
                margin-top: 0.6875rem;
                .left {
                  width: 22.25rem;
                  height: 12.5625rem;
                  float: left;
                  position: relative;
                  overflow: hidden;
                  &:hover img{
                    transform: scale(1.1);
                  }
                  img {
                    transition: all .3s; 
                  }
                  .title {
                    position: absolute;
                    bottom: 0;
                    color: #fff;
                    box-sizing: border-box;
                    width: 100%;
                    padding: 1.5rem 0.75rem 0.4375rem;
                    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.66) 100%);
                  }
                }
                .right {
                  width: 22.25rem;
                  height: 12.5625rem;
                  float: right;
                  .news {
                    height: 3.75rem;
                    margin-bottom: 0.625rem;
                    position: relative;
                    &:hover {
                      img {
                        transform: scale(1.2);
                      }
                      .title {
                        color: #006DF1;
                      }
                    }
                    .img {
                      width: 6.625rem;
                      height: 100%;
                      overflow: hidden;
                      float: left;
                      img {
                        transition: all .3s;
                      }
                    }
                    .title {
                      margin-left: 7rem;
                      height: 100%;
                      font-size: 0.875rem;
                      color: #333333;
                      line-height: 1.25rem;
                      padding-top: 0.25rem;
                      box-sizing: border-box;
                    }
                    .label {
                      top: 1px;
                      left: 1px;
                    }
                  }
                }
              }
            }
          }
        }
      }
      .content-wrapper-right {
        float: right;
        width: 15.375rem;
        .aside-subject {
          padding: 1.1875rem 0.9375rem;
          background: #F5F5F7;
          margin-bottom: 1.375rem;
          padding-top: .5rem;
          &:last-of-type {
            margin-bottom: 0;
          }
          .title {
            font-size: 1.3125rem;
            // line-height: 1.1875rem;
            // padding-left: 0.5rem;
            // border-left: 0.25rem solid #2470FF;
            color: #2470FF;
            font-weight: 500;
            padding-bottom: .4375rem;
            border-bottom: 1px solid #2470FF;
            display: flex;
            align-items: center;
            .title-name {
              width: 80%;
              margin-right: 1%;
              line-height: 1.3125rem;
            }
            &::before {
              display: inline-block;
              content: '';
              width: 0.25rem;
              height: 1.1875rem;
              background: #2470FF;
              margin-right: 0.5rem;
            }
            .seeMore {
              color: #999999;
              font-size: .6875rem;
              cursor: pointer;
            }
          }
          .news-part {
            margin-top: 0.9375rem;
            .news {
              margin-bottom: 1.25rem;
              &:hover {
                .news-title {
                  color: #006DF1;
                }
              }
              &:last-of-type {
                margin-bottom: 0;
              }
              .news-title {
                font-size: 0.8125rem;
                color: #333333;
                line-height: 1.3125rem;
                max-height: 2.625rem;
                margin-bottom: 0.3125rem;
                font-weight: 500;
              }
              .news-meta {
                font-size: 0.75rem;
                color: #999999;
                span {
                  margin-right: 0.3125rem;
                }
              }
            }
          }
          .seeAll {
            width: 3.75rem;
            height: 1.25rem;
            line-height: 1.25rem;
            text-align: center;
            font-size: 0.625rem;
            border: 1px solid #999999;
            color: #999999;
            margin: 0 auto;
          }
        }
      }
      .aside_fixed {
        position: fixed;
        bottom: 0;
        right: 14.375rem;
      }
      .aside_absolute {
        position: absolute;
        bottom: 2.5rem;
        right: 0;
      }
      .content-wrapper-NC {
        .swiper-slide {
          height: 27rem;
          .img {
            width: 48rem;
            height: 100%;
            float: left;
            position: relative;
            .video-icon {
                position: absolute;
                width: 3.1875rem;
                height: 3.1875rem;
                background: url('../assets/img/video_play.png') center no-repeat;
                background-size: cover;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
          }
          .title {
            width: 16rem;
            height: 100%;
            padding: 2.125rem 1.4375rem;
            box-sizing: border-box;
            float: left;
            background: #fff;
            color: #333333;
            font-size: 1.25rem;
            line-height: 1.875rem;
          }
        }
        .latest-kill-rumor {
          margin-top: 1.25rem;
          .list {
            .list-subject {
              width: 100%;
              height: 19.75rem;
              background: #eee;
              margin-bottom: 1.5rem;
              background: url('./../assets/img/new_subject_recommond_bg.png') center no-repeat;
              background-size: cover;
              box-sizing: border-box;
              padding: 1.1875rem;
              .title-load {
                color: #006DF1;
                .title {
                  font-size: 1.125rem;
                  line-height: 1.125rem;
                  padding-left: 0.375rem;
                  border-left: 0.25rem solid #006DF1;
                  float: left;
                }
                .seeMore {
                  font-size: 0.625rem;
                  line-height: 1.125rem;
                  float: right;
                  color: #666666;
                  img {
                    width: 0.3125rem;
                    height: 0.4375rem;
                  }
                }
              }
              .content {
                margin-top: 0.6875rem;
                .left {
                  width: 28.375rem;
                  height: 16rem;
                  float: left;
                  position: relative;
                  overflow: hidden;
                  &:hover img{
                    transform: scale(1.1);
                  }
                  img {
                    transition: all .3s; 
                  }
                  .title {
                    position: absolute;
                    bottom: 0;
                    color: #fff;
                    box-sizing: border-box;
                    padding: 1.5rem 0.75rem 0.4375rem;
                    width: 100%;
                    box-sizing: border-box;
                    background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.66) 100%);
                  }
                }
                .right {
                  width: 32.875rem;
                  height: 16rem;
                  float: right;
                  .news {
                    height: 4.875rem;
                    margin-bottom: 0.6875rem;
                    position: relative;
                    &:hover .img img{
                      transform: scale(1.2);
                    }
                    .img {
                      width: 8.625rem;
                      height: 100%;
                      overflow: hidden;
                      float: left;
                      img {
                        transition: all .3s;
                      }
                    }
                    .title {
                      margin-left: 9.25rem;
                      height: 100%;
                      font-size: 0.875rem;
                      color: #333333;
                      line-height: 1.25rem;
                      padding-top: 0.625rem;
                      box-sizing: border-box;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .wap {
    .content-wrapper {
      .swiper-container {
        .swiper-wrapper {
          .swiper-slide {
            position: relative;
            width: 100vw;
            .img {
              width: 100vw;
              height: 56.267vw;
              position: relative;
              .video-icon {
                  position: absolute;
                  width: 11.667vw;
                  height: 11.667vw;
                  background: url('../assets/img/video_play.png') center no-repeat;
                  background-size: cover;
                  top: 50%;
                  left: 50%;
                  transform: translate(-50%, -50%);
              }
            }
            .title {
              position: absolute;
              bottom: 0;
              font-size: 4.533vw;
              line-height: 6.4vw;
              color: #fff;
              width: 100vw;
              box-sizing: border-box;
              padding: 6.8vw 4vw 6.4vw;
              background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.8) 100%);
              .titleName {
                height: 12.8vw;
              }
            }
          }
        }
        .swiper-pagination {
            box-sizing: border-box;
            text-align: right;
            padding-right: 8px;
            .swiper-pagination-bullet {
              width: 6px;
              height: 6px;
              background: #D8D8D8;
              opacity: 0.5;
              outline: none;
            }
            .swiper-pagination-bullet-active {
              background: #006DF1;
              opacity: 0.7;
            }
        }
      }
      .img-box-wap {
        display: flex;
        padding: 1rem;
        justify-content: space-between;
        img {
          width: 32%;
        }
      }
    }
  }
}
</style>